const buttonCommonsPTSans = {
  fontFamily: "PT Sans",
  fontSize: ["16px", "16px", "22.5px"],
  fontStyle: "normal",
  fontWeight: "400"
}
export const ButtonTextStyles = {
  Button1BigPTDecor: {
    ...buttonCommonsPTSans,
    lineHeight: "40px",
    textDecoration: "underline"
  },
  Button1BigPT: {
    ...buttonCommonsPTSans,
    lineHeight: "26px"
  },
  Button1Big: {
    ...buttonCommonsPTSans,
    fontFamily: "Work Sans",
    lineHeight: "24px"
  },
  Button1CAPS: {
    fontFamily: "Work Sans",
    fontSize: "16px",
    fontWeight: "500 !important",
    lineHeight: "19px",
    textTransform: "uppercase"
  },
  Button1Regular: {
    fontFamily: "Work Sans",
    fontSize: ["12px", "16px", "16px", "16px", "16px"],
    fontWeight: "400",
    lineHeight: "19px"
  },
  Button1Small: {
    fontFamily: "Work Sans",
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "15px"
  },
  Button2Small: {
    fontFamily: "PT Sans",
    fontWeight: "600",
    fontSize: "12px",
    lineHeight: "15px"
  },
  Button2Big: {
    ...buttonCommonsPTSans,
    fontSize: "15px",
    lineHeight: "18px"
  },
  Button2Bold: {
    ...buttonCommonsPTSans,
    fontWeight: 700,
    fontSize: ["16px", "16px", "14px"],
    lineHeight: ["19px", "19px", "17px"]
  },

  Button3PT: {
    ...buttonCommonsPTSans,
    fontWeight: 400,
    fontSize: "10px",
    lineHeight: "13px"
  },
  Button3Work: {
    fontFamily: "Work Sans",
    fontWeight: 400,
    fontSize: "10px",
    lineHeight: "13px"
  },
  Button2NoDecor: {
    ...buttonCommonsPTSans,
    fontSize: "15px",
    lineHeight: "18px"
  }
}
